import React from "react";

function Project() {
  return (
    <div>
      <h>Project</h>
    </div>
  );
}

export default Project;
